'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAndCheckWitHeaders = exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

require("whatwg-fetch");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchAndCheck = function fetchAndCheck(url, options) {
  return fetch(url, options).then(function (res) {
    if (res.ok) {
      return res.json().then(function (body) {
        var status = (0, _lodash.default)(body, 'error.status');

        if (status && status > 200) {
          return Promise.reject(body);
        }

        return body;
      });
    } else {
      var error = new Error(res.statusText);
      error.status = res.status;
      return res.json().catch(function () {
        if (res.status === 403 && res.statusText === 'Forbidden') return Promise.reject(new Error('Rejected by WAF'));
        return Promise.reject(error);
      }).then(function (err) {
        return Promise.reject(err);
      });
    }
  });
};

var _default = fetchAndCheck;
exports.default = _default;

var fetchAndCheckWitHeaders = function fetchAndCheckWitHeaders(url, options) {
  return fetch(url, options).then(function (res) {
    if (res.ok) {
      return res.json().then(function (body) {
        var status = (0, _lodash.default)(body, 'error.status');

        if (status && status > 200) {
          return Promise.reject(body);
        }

        return {
          headers: res.headers,
          body: body
        };
      });
    } else {
      var error = new Error(res.statusText);
      error.status = res.status;
      return res.json().catch(function () {
        if (res.status === 403 && res.statusText === 'Forbidden') return Promise.reject(new Error('Rejected by WAF'));
        return Promise.reject(error);
      }).then(function (err) {
        return Promise.reject(err);
      });
    }
  });
};

exports.fetchAndCheckWitHeaders = fetchAndCheckWitHeaders;


//////////////////
// WEBPACK FOOTER
// ./client/components/advanced-fetch/index.js
// module id = 97
// module chunks = 0